"use strict";var e=require("react");exports.usePassword=(r,s)=>{const[t,u]=e.useState(null!=r?r:"");return[t,e.useCallback(((e,t)=>{void 0===r&&u(e),null==s||s(e,t)}),[r,s])]};
